import * as React from "react";
import "./master-table-2.scss";
import {cx} from "emotion";
import {UseState} from "../../../../../../../../react/use-state";
import {cs} from "../../../../../../../../react/chain-services";
import {keyed} from "../../../../../../../../react/keyed";
import {chain} from "../../../../../../../../utils/fs";
import {reverse, sort, sum} from "../../../../../../../../utils/collections";
import {Sorting} from "../../../../../../common/design2/data-table/sorting";

export const MasterTable2 = ({className=undefined, list, columns, noDataMessage="No data...", getFooter}) => cs(

    ["sorting", (_, next) => Sorting({
        // getDefault: getDefaultSorting,
        next,
    })],

    ["sortedList", ({sorting}, next) => next(!list || !sorting.value ? list : chain(
        list,
        (_) => sorting.apply(_, (row, columnIndex) => row.columns[columnIndex].sortValue()),
    ))],

    ({sorting, sortedList}) => (
        <table className={cx("master-table master-table-2-3de", className)}>
            <thead>
            <tr>
                <th className="padding left">&nbsp;</th>
                {columns.map((column, i) => {
                    const sorted = sorting.isSortingActiveForColumn({columnIndex: i});
                    return (
                        <th {...{
                            className: cx(
                                "column",
                                {
                                    sortable: column.sorting,
                                    sorted,
                                },
                                column.align && "align-" + column.align,
                            ),
                            key: i,
                            "xd-qa-type": "style_filter",
                            "xd-qa-name": "Coop Condo List " + column.label + " sort",
                            onClick: !column.sorting ? null : () => sorting.toggleColumn({
                                columnIndex: i,
                                // defaultDirection: col.sortable.defaultDirection,
                            }),
                        }}>
                            <div className="label" xd-qa-type="label" xd-qa-name={ `Coop Condo List ${column.label}` }>
                                {column.label}
                            </div>

                            {column.sorting && (
                                <i
                                    className={(sorted && sorting.direction) === "asc" ? (
                                        "fa fa-caret-up"
                                    ) : (
                                        "fa fa-caret-down"
                                    )}
                                    xd-qa-type="icon"
                                    xd-qa-name={ `Coop Condo List ${column.label} sort`}
                                />
                            )}
                        </th>
                    );
                })}
                <th className="padding right">&nbsp;</th>
            </tr>
            </thead>

            <tbody>
            {!sortedList.length && (
                <tr className="no-data">
                    <td colSpan={columns.length + 2}>{noDataMessage}</td>
                </tr>
            )}
            {sortedList.map((row, i) => cs(
                keyed(row.key ?? i),
                ({}) => <>
                    <tr
                        className={cx(
                            "master-record",
                            {
                                expanded: row.getExpansion,
                                grey: i % 2 === 1
                            },
                        )}
                    >
                        <td className="padding">&nbsp;</td>

                        {columns.map((column, j) => (
                            <td
                                className={cx("column", column.align && "align-" + column.align,)}
                                xd-qa-type="text"
                                xd-qa-name={ ( row.xdQaRowId ?? i ) + " " + column.label }
                                key={j}
                            >
                                {row.columns[j].renderCell(i, {expanded: row.getExpansion})}
                            </td>
                        ))}

                        <td className="padding">&nbsp;</td>
                    </tr>

                    {row.getExpansion && (
                        <tr className={cx("expansion", {grey: i % 2 === 1})}>
                            <td colSpan={columns.length + 3}>
                                <div className="box">
                                    {row.getExpansion({grey: i % 2 === 1})}
                                </div>
                            </td>
                        </tr>
                    )}
                </>,
            ))}
            </tbody>

            {renderFooter({getFooter, colCount: columns.length})}
        </table>
    ),
);

const renderFooter = ({getFooter, colCount}) => chain(
    getFooter?.({colCount: colCount + 1}),
    (footer) => footer && (
        <tfoot>
        <tr>
            <td className="padding"/>
            {footer.columns.map((col, i) => (
                <td key={i} className={col.className} colSpan={col.colSpan} {...col.domAttrs}>
                    {col.render?.()}
                </td>
            ))}

            {chain(
                colCount + 1 - sum(footer.columns, (c) => c.colSpan??1),
                (remainingCol) => !!remainingCol && (
                    <td colSpan={remainingCol}>&nbsp;</td>
                ),
            )}
        </tr>
        </tfoot>
    ),
);